import Vue from 'vue';
import _store from '@/store';

export {_store as store};

//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Variable                                                              //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//
export const state = {
  store: _store.state,
  // States from Vuex store
  local: Vue.observable({
    // Setup local state here (States which don't shared or long-term keeping);

    isProcessing: false,

    courseOutline: null,

    //manual data
    selectedSubject: null,
    selectedTeacher: null,
    subjects: [],
    courseOutlines: [],
    showWarningNoClassRoom: false,

    //classRoom edit
    courseOutlineAssessmentEdit: {
      id: '',
      courseOutline: null,
      assessment: null,
      seq: 1,
      percent: 0,
      score: 0,
    },

    //subject info
    subjectInfo: {
      classSection: null
    },

    // teacher edit
    teacherEdit: {
      selectedTeacher: null
    },

    //edit page
    courseOutlineEdit: {
      id: '',
      form: {
        courseOutlineInput: {
          periodCode: '',
          degreeCode: '',
          subjectGroupCode: '',
          subjectCode: '',
          subjectName: '',
          teacherCode: '',
          sectionNo: '',
          teacherFullName: '',
          topicLocal: '',
          topicEng: '',
          dateTimeFrom: new Date(),
          dateTimeTo: new Date(),
          liveFrom: '',
          contract: '',
          remark: '',
          rtmpServer: '',
          rtmpStream: '',
          isEnabled: true,
        },
      },
    },


  })
};

export const template = {
  table: {
    header: [
      {title: 'live-class-schedule.no', id: 'no'},
      {title: 'live-class-schedule.subject-code', id: 'subjectCode'},
      {title: 'live-class-schedule.subject-name', id: 'subjectName'},
      {title: 'live-class-schedule.teacher', id: 'teacher'},
      {title: 'course-outline.course-outline-unit-qty', id: 'courseOutlineUnitQty'},
      {title: '', id: ''},
    ]
  },
};


//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Function                                                              //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//


export const loadData = async (func) => {

  if ((state.local.selectedSubject && state.local.selectedSubject.id)
    || (state.local.selectedTeacher && state.local.selectedTeacher.id)) {

    let payload = {
      courseOutlineFilterInput: {
        subjectId: state.local.selectedSubject ? state.local.selectedSubject.id : '',
        teacherId: state.local.selectedTeacher ? state.local.selectedTeacher.id : '',
      }
    };

    if (func.getCourseOutlinesByFilterForTable) {
      let result = await func.getCourseOutlinesByFilterForTable(payload);

      if(result && result.length > 0){
        state.local.courseOutlines = result;
      }else {
        state.local.courseOutline = []
      }
    }
  }

};

//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Private Function                                                      //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//
